import { ActionContext } from "vuex";

interface State {
  data: boolean;
}

const state: State = {
  data: false,
};

const getters = {
  getList: (state: State) => state.data,
};

const actions = {};

const mutations = {
  SET_LIST(state: State, data: boolean) {
    state.data = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
